import moment from "moment/moment";

export const isMantenance = (data) =>
     moment().startOf('day').isSameOrAfter(moment(data?.start_date, 'YYYY-MM-DD').startOf('day')) &&
     moment().startOf('day').isSameOrBefore(moment(data?.end_date, 'YYYY-MM-DD').startOf('day'))
